<!-- ========== Left Sidebar Start ========== -->

<!--- Sidemenu -->

<ul class="metismenu" id="side-menu" #sideMenu>
  <ng-container *ngFor="let item of menuItems">
    <li class="side-nav-title side-nav-item menu-title" *ngIf="item.isTitle">{{ item.label }}</li>

    <li *ngIf="!item.isTitle" >

      <a *ngIf="hasItems(item)" href="javascript:void(0);" class="side-nav-link">
        <i [attr.data-feather]="item.icon" class="icon-dual icon-xxl" appFeatherIcon *ngIf="item.icon"></i>
        <span class="text-uppercase"> {{ item.label }}</span>
        <span class="menu-arrow"></span>
      </a>

      <a [routerLink]="[item.link]" *ngIf="!hasItems(item)" class="side-nav-link side-nav-link-ref"
        [attr.data-parent]="item.parentId">
        <i [attr.data-feather]="item.icon" appFeatherIcon *ngIf="item.icon"></i>
        <span> {{ item.label }}</span>
        <span class="badge rounded-circle badge-{{item.badge.variant}} float-right" *ngIf="item.badge">{{item.badge.text}}</span>
      </a>
    </li>
  </ng-container>
</ul>
